import { isRceEditConfig } from 'config/utils/config'
import type {
  RCEVoucherTopCandidate,
  StandardVoucherTopCandidate,
  VoucherTopBannerModel
} from '../VoucherBanner.types'

interface ResolveVoucherTopBannerInput {
  configName?: string
  isReady: boolean
  standard: StandardVoucherTopCandidate
  rce: RCEVoucherTopCandidate
}

export const resolveVoucherTopBanner = ({
  configName,
  isReady,
  standard,
  rce
}: ResolveVoucherTopBannerInput): VoucherTopBannerModel => {
  if (!isReady || !configName) {
    // `reason` is for observability only and doesn't drive any control logic.
    return { kind: 'hidden', reason: 'startup-unresolved' }
  }

  return isRceEditConfig(configName) ? rce : standard
}
